import React, { useState } from 'react'

const Searchbar = ({searchMembers, setSearchMembers}) => {
    
    return (
        <>
            {/* ----Search Bar--- */}
            <div className="flex items-center shadow-[0_5px_10px_0_rgba(37,73,242,0.15)] rounded-[10px] h-[50px] mt-4">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 mx-2"
                    viewBox="0 0 14 14"
                    fill="none"
                >
                    <path
                        d="M6.70866 12.2498C9.76924 12.2498 12.2503 9.76875 12.2503 6.70817C12.2503 3.64759 9.76924 1.1665 6.70866 1.1665C3.64808 1.1665 1.16699 3.64759 1.16699 6.70817C1.16699 9.76875 3.64808 12.2498 6.70866 12.2498Z"
                        stroke="#8387BD"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12.8337 12.8337L11.667 11.667"
                        stroke="#8387BD"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <input
                    placeholder="Search"
                    className="w-full p-2 focus:outline-none"
                    type="text"
                    value={searchMembers}
                    onChange={(e) => setSearchMembers(e.target.value)}
                />
            </div>
        </>
    )
}

export default Searchbar
